import { useField } from "react-final-form";

export const useFormFieldValue = (key) => useField(key)?.input?.value;
